import React from "react";
import { FaCircleNotch } from "react-icons/fa";

interface Props {
  size?: number;
  className?: string;
}

const LoadingSpinner = ({ size = 24, className = "" }: Props) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <FaCircleNotch
        style={{ width: size, height: size }}
        className="text-gray-500 animate-spin"
        aria-hidden="true"
      />
      <span className="sr-only">Loading</span>
    </div>
  );
};

export default LoadingSpinner;
